import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'burncase-description',
    templateUrl: './description.component.html',
    styleUrls: ['./description.component.css']
})
export class DescriptionComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
